export const cMenuBg = '#000000dd'
export const cPrimary = 'lime'
